/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTiktok } from "react-icons/fa";
import "../App.css";
import { useLanguage } from "../i18n/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer-container">
      <div className="footer-content container">
        <div className="footer-brand">
          <h4>HoneyBuzz</h4>
          <p>{t("footer.tagline")}</p>
          <p className="copyright">&copy; 2026 HoneyBuzz</p>
        </div>

        <div className="footer-links">
          <div>
            <h5>{t("footer.shop")}</h5>
            <ul>
              <li><Link to="/products">{t("footer.allHoney")}</Link></li>
              <li><Link to="/cart">{t("footer.cart")}</Link></li>
            </ul>
          </div>

          <div>
            <h5>{t("footer.support")}</h5>
            <ul>
              <li><a href="mailto:hello@honeybuzz.example">{t("footer.contact")}</a></li>
              <li><Link to="/admin/login">{t("footer.admin")}</Link></li>
            </ul>
          </div>

          <div>
            <h5>{t("footer.follow")}</h5>
            <div className="social-icons">
              <a href="#" aria-label="Facebook"><FaFacebook /></a>
              <a href="#" aria-label="Instagram"><FaInstagram /></a>
              <a href="#" aria-label="TikTok"><FaTiktok /></a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
